import { render, staticRenderFns } from "./unsaved-changes-modal.vue?vue&type=template&id=77fc3a3c"
import script from "./unsaved-changes-modal.vue?vue&type=script&lang=js"
export * from "./unsaved-changes-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports